export default "__VITE_PUBLIC_ASSET__745b2ac5__"